var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"vehicle-icon",style:(_vm.cssVars),attrs:{"src":_vm.vehicleIcon}})}
var staticRenderFns = []

export { render, staticRenderFns }